module.exports = __webpack_public_path__ + "static/media/f_faceshape_oval_vector.fa9ce2cb.svg";